import Vue from 'vue'
import Component from '../shared/component'

export const NumberFormat = Component('v-number-format', {
  functional: true,
  props: {
    value: {
      type: [
        String,
        Number
      ],
      default: null,
      required: true
    },
    format: {
      type: String,
      default: 'decimal',
      valid: [
        'decimal',
        'currency',
        'percent'
      ]
    },
    currency: {
      type: String,
      default: null
    },
    display: {
      type: String,
      default: 'symbol',
      valid: [
        'symbol',
        'code',
        'name'
      ]
    },
    group: {
      type: Boolean,
      default: true
    }
  },
  render (createElement, { props }) {
    let { value, format, currency, group, display } = props

    const number = value.constructor === Number
      ? value
      : Number(value)

    const options = {
      style: format,
      useGrouping: group
    }

    if (currency) {
      Object.assign(options, {
        currency,
        currencyDisplay: display
      })
    }

    return createElement(
      'span',
      {
        class: 'number'
      },
      [
        number.toLocaleString(Vue.config.locale, options)
      ]
    )
  }
})
